import { withPopup } from '../Utils';
import MembershipActionsStep from './MembershipActionsStep';

export default withPopup(MembershipActionsStep);
